import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const LegalTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={containerClass}>
       <div className="flex h-full">
           {/* Line Numbers Sidebar */}
           <div className="w-12 bg-neutral-100 border-r border-neutral-300 flex flex-col items-center pt-12 text-neutral-400 font-mono text-xs leading-[2rem]">
               {Array.from({length: 30}).map((_, i) => <div key={i}>{i+1}</div>)}
           </div>

           <div className="flex-1 p-16 font-serif">
               {!hideHeader && (
                 <>
                   <div className="text-center mb-12 border-b-2 border-double border-neutral-300 pb-8">
                       <h1 className="text-3xl font-bold uppercase tracking-widest text-neutral-900 mb-2">{profile.name}</h1>
                       <p className="text-xs text-neutral-500 uppercase tracking-widest">Official {type} Document</p>
                   </div>

                   <div className="mb-8 text-sm leading-relaxed text-neutral-800">
                       <p className="font-bold mb-2 uppercase text-xs tracking-wider">I. Parties</p>
                       <p className="mb-4">
                           This document is presented by <strong>{profile.name}</strong> (hereinafter referred to as "Provider") located at {profile.address}, to
                           {client ? <strong> {client.name}</strong> : " the Client"} (hereinafter referred to as "Recipient").
                       </p>

                       <p className="font-bold mb-2 uppercase text-xs tracking-wider">II. Particulars</p>
                       <div className="grid grid-cols-2 gap-4 mb-8">
                           {metaData.map((m, i) => (
                               <div key={i} className="flex gap-2">
                                   <span className="font-bold">{m.label}:</span>
                                   <span className="italic underline decoration-slate-300 underline-offset-4">{m.value}</span>
                               </div>
                           ))}
                       </div>
                   </div>
                 </>
               )}

               <div className="flex-1 legal-table mb-12">
                   <p className="font-bold mb-4 uppercase text-xs tracking-wider">III. Schedule of Items</p>
                   {children}
               </div>

               <div className="border-t border-neutral-300 pt-8">
                   <p className="font-bold mb-2 uppercase text-xs tracking-wider">IV. Certification</p>
                   <p className="text-xs text-neutral-500 italic mb-8">{footerNote}</p>
                   
                   <div className="flex justify-between mt-12">
                       <div className="border-t border-neutral-900 w-48 pt-2">
                           <p className="text-xs font-bold uppercase">Authorized Signature</p>
                       </div>
                       <div className="border-t border-neutral-900 w-32 pt-2">
                           <p className="text-xs font-bold uppercase">Date</p>
                       </div>
                   </div>
               </div>
           </div>
       </div>
    </div>
  );
};

export default LegalTemplate;